import React, { useEffect } from 'react';
import '../../styles/BlogPost.css';
import '../../styles/InputLagCalculator.css';

const InputLagCalculator = () => {
  useEffect(() => {
    function toggleAccordion(accordionElement) {
      if (accordionElement.style.maxHeight) {
        accordionElement.style.maxHeight = null;
      } else {
        accordionElement.style.maxHeight = accordionElement.scrollHeight + "px";
      }
    }

    function handleButtonClick(buttonId) {
      const delayInputId = 'delay' + buttonId.match(/\d+/)[0];
      const delay = parseInt(document.getElementById(delayInputId).value, 10);
      const button = document.getElementById(buttonId);
      const accordionId = 'accordion' + buttonId.match(/\d+/)[0];
      const accordion = document.getElementById(accordionId);
      const responseDiv = document.getElementById('responseTime');
      const startTime = Date.now();
      
      // Disable the button during the delay
      button.disabled = true;
      button.style.backgroundColor = '#555';
      
      setTimeout(function() {
        const endTime = Date.now();
        const actualDelay = endTime - startTime;
        
        button.style.backgroundColor = '#106ba3';
        button.disabled = false;
        
        // Update accordion content with the delay information
        const content = accordion.querySelector('.content');
        content.innerHTML = `
          <p><strong>Measured Delay: ${actualDelay}ms</strong></p>
          <p>This interaction would be considered:</p>
          <p style="color: ${actualDelay <= 200 ? '#2da44e' : actualDelay <= 500 ? '#bf8700' : '#cf222e'}">
            <strong>${actualDelay <= 200 ? '✓ Good' : actualDelay <= 500 ? '⚠ Needs Improvement' : '✕ Poor'}</strong>
          </p>
          <p>According to Google's INP thresholds:</p>
          <ul>
            <li>Good: ≤ 200ms</li>
            <li>Needs Improvement: ≤ 500ms</li>
            <li>Poor: > 500ms</li>
          </ul>
        `;
        
        toggleAccordion(accordion);
        responseDiv.textContent = `Response time for Button ${buttonId === 'button200' ? '1' : '2'}: ${actualDelay}ms`;
      }, delay);
    }

    // Set up event listeners
    const button200 = document.getElementById('button200');
    const button300 = document.getElementById('button300');
    
    const handleButton200Click = () => handleButtonClick('button200');
    const handleButton300Click = () => handleButtonClick('button300');
    
    if (button200) {
      button200.addEventListener('click', handleButton200Click);
    }
    if (button300) {
      button300.addEventListener('click', handleButton300Click);
    }

    // Cleanup
    return () => {
      if (button200) {
        button200.removeEventListener('click', handleButton200Click);
      }
      if (button300) {
        button300.removeEventListener('click', handleButton300Click);
      }
    };
  }, []);

  return (
    <div className="blog-post-page">
      <div className="blog-post-container">
        <div className="blog-post-content-wrapper">
          <h1 className="blog-post-title">INP Visualiser</h1>
          <div className="blog-post-meta">An interactive tool to visualize and understand Input Delay</div>
          
          <div className="blog-post-content calc">
            <div className="container">
              <label htmlFor="delay200">Set Delay for Button 1 (ms):</label>
              <input type="number" id="delay200" className="delay-input" defaultValue="200" min="0" />
              <button className="button" id="button200">Click me (Button 1)</button>
              <div id="accordion200" className="accordion">
                <div className="content"></div>
              </div>

              <label htmlFor="delay300">Set Delay for Button 2 (ms):</label>
              <input type="number" id="delay300" className="delay-input" defaultValue="800" min="0" />
              <button className="button" id="button300">Click me (Button 2)</button>
              <div id="accordion300" className="accordion">
                <div className="content"></div>
              </div>

              <div id="responseTime" className="response-time"></div>
            </div>
          </div>

          <div className="blog-post-content">
            <h2>What is this tool?</h2>
            <p>
              The INP visualiser is an interactive simulator that allows users to adjust the delay time in milliseconds for webpage elements and observe how this affects their responsiveness. By clicking on buttons, users can compare the performance of elements side-by-side, gaining insights into the impact of delays on user experience.
            </p>

            <h2>How do I use the visualiser?</h2>
            <p>
              Users can input a desired delay time in milliseconds using the provided input box. Upon interacting with the buttons on the page, they will experience a delay, as specified, before the accordion with lorem ipsum text appears. This feature allows for a direct comparison of different delay times, enabling users to visually perceive the effect of response times on user interaction.
            </p>

            <h2>Why create a tool like this?</h2>
            <p>
              When Google rolls out a new standard for Core Web Vitals we can find ourselves chasing a 'Good' score with little thought of how these changes will impact user experience. If your INP score sits at 220ms for a group of pages Search Console will state that it 'Needs Improvement'. However, the time, effort, and $ spent trying to shave off those 20ms could be directed towards other initiatives that will have a greater impact on user experience.
            </p>
            <p>
              This tool is designed to make the often abstract concept of webpage responsiveness tangible. By allowing users to manipulate and observe the effect of input delay, it provides a hands-on understanding of how response times can affect user experience. This understanding is crucial for developers and designers in optimising web performance and user experience.
            </p>

            <h2>What are the tool's limitations?</h2>
            <p>
              While this tool effectively demonstrates the impact of delays on individual elements, it's important to remember that it does not replicate the full scope of real-world user interactions or the comprehensive INP metric. INP considers a variety of interactions and paints a broader picture of page responsiveness, which this tool, focusing on specific elements and controlled delays, does not fully capture.
            </p>

            <h2>Where can I learn more about INP?</h2>
            <p>
              The best place to start is <a href="https://web.dev/articles/inp" target="_blank" rel="noopener noreferrer">Web.Dev's official documentation</a>.
            </p>
            <p>
              The metric won't be rolled out until March 2023, but you can see your INP scores in Google Search Console.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InputLagCalculator; 